import React, { useState } from 'react';
// Import Libraries
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import chevronLeft from '../../assets/images/chevronLeft.svg';
import { FaTimes } from 'react-icons/fa';

const LightboxStyles = styled.div`
	#lightbox {
		z-index: 1;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: space-between;
		#lightbox-img {
			height: fit-content;
			max-width: 100%;
			object-fit: contain;
			margin: auto;
		}
		.lightbox-arrow {
      z-index: 1;
      position: absolute;
      
      width: 48px;
      height: 48px; 
      background: var(--primary-500);
      border-radius: 50%;
      font-size: 0;
			border: none;

      &:before {
        content: '';
        background-image: url(${chevronLeft});
        filter: invert(100%) sepia(2%) saturate(2%) hue-rotate(354deg)
          brightness(118%) contrast(100%);
        background-size: 20px;
        background-position: center;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        display: block;
      }
      &.lightbox-prev {
        /* bottom: 100px; */
				left: 8px;
      }
      &.lightbox-next {
        /* bottom: 18px; */
				right: 8px;

        &:before {
          transform: rotate(180deg);
        }
      }
    }
		.closeBtn {
			position: absolute;
			right: 24px;
			top: 120px;
			color: white;
			font-size: 24px;
		}
	}
`;

const Lightbox = ({ images, isLightboxOpen, setIsLightboxOpen, hotelName }) => {
	const [imageToShow, setImageToShow] = useState(images[0]);

	//hide lightbox
	const hideLightBox = () => {
		setIsLightboxOpen(false);
	};

	//show next image in lightbox
	const showNext = (e) => {
		e.stopPropagation();
		let currentIndex = images.indexOf(imageToShow);
		let nextImage =
			currentIndex >= images.length - 1 ? images[0] : images[currentIndex + 1];
		setImageToShow(nextImage);
	};

	//show previous image in lightbox
	const showPrev = (e) => {
		e.stopPropagation();
		let currentIndex = images.indexOf(imageToShow);

		let nextImage =
			currentIndex <= 0 ? images[images.length - 1] : images[currentIndex - 1];
		setImageToShow(nextImage);
	};

	return (
		<LightboxStyles>
			{isLightboxOpen ? (
				<div id='lightbox' onClick={hideLightBox}>
					<FaTimes className='closeBtn' onClick={hideLightBox} />
					<button className="lightbox-arrow lightbox-prev" onClick={showPrev}>prev</button>
					{/* <img id="lightbox-img" src={imageToShow}></img> */}

					<GatsbyImage
						image={getImage(imageToShow.asset)}
						alt={hotelName}
						id='lightbox-img'
					/>

					<button className="lightbox-arrow lightbox-next" onClick={showNext}>next</button>
				</div>
			) : (
				''
			)}
		</LightboxStyles>
	);
};

export default Lightbox;
